import { drawerStore } from 'ats/components/drawer/DrawerStore';

export function syncFilterDrawerProps(page) {
	if (
		!drawerStore.isOpen ||
		drawerStore.drawerId !== drawerStore.DRAWER_IDS.FILTER_DRAWER ||
		typeof page.getDrawerFilters !== 'function'
	) {
		return;
	}

	drawerStore.updateDrawerProps({ filters: page.getDrawerFilters() });
}
